import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { BasketProvider } from "./context/BasketContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { FlashLock } from "./components/FlashLock";
import { BasketSync } from "./components/BasketSync";
import { SEO } from "./components/SEO";
import Home from "./pages/Home";
import DealDetail from "./pages/DealDetail";
import DealsPage from "./pages/DealsPage";
import AuthPage from "./pages/AuthPage";
import BasketPage from "./pages/BasketPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import HowItWorks from "./pages/HowItWorks";
import SellToUs from "./pages/SellToUs";
import AdminPage from "./pages/AdminPage";
import AuctionsPage from "./pages/AuctionsPage";
import AuctionDetail from "./pages/AuctionDetail";
import LegalPage from "./pages/LegalPage";
import PaymentReturn from "./pages/PaymentReturn";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="noise-overlay min-h-screen bg-[#0A0A0A] text-white">
      <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <BasketProvider>
            <SEO />
            <BasketSync />
            <ScrollToTop />
            <FlashLock />
            <Navbar />
            <main className="min-h-[60vh]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/deals" element={<DealsPage status="live" />} />
                <Route path="/coming-soon" element={<DealsPage status="coming_soon" />} />
                <Route path="/deal/:slug" element={<DealDetail />} />
                <Route path="/join" element={<AuthPage mode="join" />} />
                <Route path="/login" element={<AuthPage mode="login" />} />
                <Route path="/basket" element={<BasketPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/sell-to-us" element={<SellToUs />} />
                <Route path="/reverse-auction" element={<AuctionsPage />} />
                <Route path="/reverse-auction/:slug" element={<AuctionDetail />} />
                <Route path="/legal/:page" element={<LegalPage />} />
                <Route path="/payment-return" element={<PaymentReturn />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: { background: "#111111", color: "#fff", border: "1px solid #27272A", borderRadius: 0, fontFamily: "IBM Plex Mono, monospace", fontSize: "13px" },
              }}
            />
          </BasketProvider>
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
